meedy.controller('meedy.settingsReportListController', ['$scope', '$state', 'reportModel', '$mdDialog',
    function ($scope, $state, reportModel, $mdDialog) {


        function setData() {
            var date = new Date();
            $scope.loading = false;

            $scope.criteria = {
                visitBook: {
                    startDate: date,
                    endDate: date
                }
            };
        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {

            $scope.onClick = function(reportName){
                var startDate = prepareDate(new Date($scope.criteria[reportName].startDate));
                var endDate = prepareDate(new Date($scope.criteria[reportName].endDate));

                $scope.loading = true;
                reportModel.downloadReport('edmVisitReport', startDate, endDate).then(function() {
                    $scope.loading = false;
                }).catch(function () {
                    $scope.loading = false;
                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/popup/popup-error.html',
                        controller: 'popupErrorController',
                        resolve: {
                            error: function () {
                                return {
                                    additionalMessage: 'T.SYSTEM.ERROR.INTERNAL_ERROR',
                                    title: 'T.SYSTEM.ERROR.ERROR'
                                };
                            }
                        }
                    });
                });
            };
        }

        function configureInterface() {

        }

        function initialize() {

        }

        function prepareDate(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();

            if(month < 10) {
                month = '0'+ month;
            }
            if(day < 10) {
                day = '0'+ day;
            }

            var dateString = year + '-' + month + '-' + day;

            return dateString;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
